import { render, staticRenderFns } from "./PageNewProject.vue?vue&type=template&id=3a434512"
import script from "./PageNewProject.vue?vue&type=script&lang=js"
export * from "./PageNewProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports